import { createSlice } from '@reduxjs/toolkit'
import { fetchAccountSummary, GetAccount } from '../thunks/accountSummary'

export const accountSummarySlice = createSlice({
    name: 'accountSummary',
    initialState: {
        accountSummary: {},
        accountId: null,
        accountData: {}
    },
    reducers: {
        setAccountSummary: (state, action) => {
            state.accountSummary = action.payload
        },
        setAccountId: (state, action) => {
            state.accountId = action.payload
        },
        setAccountData: (state, action) => {
            state.accountData = action.payload
        },
    },
    extraReducers: (builders) => {
        builders.addCase(GetAccount?.fulfilled, (state, action) => {
            state.accountId = action.payload
        }).addCase(fetchAccountSummary?.fulfilled,(state,action) => {
            state.accountSummary = action.payload
        })
    },
})

export const { setAccountSummary, setAccountId, setAccountData } = accountSummarySlice.actions
export default accountSummarySlice.reducer